import React from 'react';
import { Dialog } from '@cainiaofe/cn-ui';
import './index.scss';

interface IStickyBarProps {
  visible?: boolean;
  title?: string;
  button?: {
    text: string;
    onClick: () => void;
    confirm?: {
      title: string;
      content: string;
    };
  };
}

const StickyBar = (props: IStickyBarProps) => {
  const { visible, title, button } = props;

  if (!visible) return null;

  return (
    <div className="stickyBar">
      <span>—— </span>
      <span>{title}</span>
      {button ? (
        <span
          className="link"
          onClick={() => {
            if (button.confirm) {
              Dialog.confirm({
                title: button.confirm?.title,
                content: button.confirm?.content,
                // size: 'small',
                onOk: () => {
                  button.onClick();
                },
              });
            } else {
              button.onClick();
            }
          }}
        >
          {button.text}
        </span>
      ) : null}
      <span> ——</span>
    </div>
  );
};

export default StickyBar;
